import { createReducer } from 'redux-act';

import { viewChanged } from '../actions/management/viewChanged';

export enum SelectedViewType {
  MAP = 'MAP',
  SCHEDULE = 'SCHEDULE',
}

export interface ManagementPageState {
  selectedView: SelectedViewType;
}

const defaultState = {
  selectedView: SelectedViewType.SCHEDULE,
};

const managementPageReducer = createReducer<ManagementPageState>({}, defaultState);

managementPageReducer.on(viewChanged, (managementPageState, { selectedView }) => ({
  ...managementPageState,
  selectedView,
}));

export default managementPageReducer;
